import { gql } from '@apollo/client'

const getManagerUsers = gql`
  query managerUsers($fsUserName: String) {
    managerUsers(fsUserName: $fsUserName) {
      firstName
      lastName
      id
    }
  }
`

export default getManagerUsers
